export const isCI = process.env.CI;
export const isVercelPreview = process.env.VERCEL_ENV === "preview";
